const HomeAbout = () => {
  return (
    <div className="section bg-dark overflow-hidden">
      <div className="about-section section-padding mt-n3 mb-n1">
        <div
          className="about-images"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/about1.jpg)`,
          }}
        ></div>

        <div className="container">
          <div
            className="row justify-content-end"
            data-aos="fade-up"
            data-aos-duration="1200"
          >
            <div className="col-lg-6">
              <div className="about-content">
                <h3 className="title">Harmeet Singh</h3>
                <p className="about-text">
                  With over 4 years of professional experience, I specialize in
                  building scalable web applications and interactive user
                  experiences using modern technologies like React, Angular, and
                  GraphQL.
                </p>
                <p>
                  I have led projects for a major US-based fintech company,
                  delivering real-time data visualization dashboards, robust
                  APIs, and seamless user interfaces. My work ensures high
                  performance and reliability, meeting global industry
                  standards. <br /> <br />
                  From architecting solutions for fintech to optimizing cloud
                  deployments on AWS, I focus on creating efficient,
                  user-centric applications that drive value for businesses.
                </p>
                <p>
                  I thrive on solving complex problems and am committed to
                  continuous learning, exploring cutting-edge technologies to
                  enhance application performance and user satisfaction.
                </p>
                {/* <img
                  className="signechar"
                  src="./images/signechar.png"
                  alt=""
                /> */}
                {/* <h6 className="name">Harmeet Singh</h6> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAbout;
